<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.technical__7_sustainability')}}</h4>
    <p>
      {{$t('medium_grant.technical__7_sustainability_sub')}}
    </p>
    <div class="row">
      <div class="col-lg-12">
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.technical.sustainability"
            >
            </textarea>
        </base-input>

        <p class="mt-5">
          {{$t('medium_grant.technical__7_sustainability_sub2')}}
        </p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.technical.sustainability2"
            >
            </textarea>
        </base-input>

        <div class="mt-5"></div>
        <h4 class="card-title">{{$t('medium_grant.technical__8_complementary')}}</h4>
        <p>
          {{$t('medium_grant.technical__8_complementary_sub')}}
        </p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.technical.complementarySynergy"
            >
            </textarea>
        </base-input>

        <div class="mt-5"></div>
        <h4 class="card-title">{{$t('medium_grant.technical__9_communication')}}</h4>
        <p>
          {{$t('medium_grant.technical__9_communication_sub')}}
        </p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.technical.communicationVisibility"
            >
            </textarea>
        </base-input>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
